<template>
    <div>
        <el-dialog :title="$t('train.addTrainee')"
                   width="70%"
                   top="10vh"
                   custom-class="trainee-dialog"
                   :visible.sync="visible"
                   :close-on-click-modal="false"
                   :append-to-body="true"
                   :modal-append-to-body="true">
            <el-form :inline="true" :model="formSearch" class="dialog-form" size="mini">
                <el-form-item :label="$t('c.userInfo')+'：'">
                    <el-input v-model="formSearch.search" :placeholder="$t('tip.userSearch')"
                              @keyup.enter.native="getDialogUsers" clearable></el-input>
                </el-form-item>
                <select-multiple v-if="visible && !notStudent" :nameArrays="selectNames"
                                 v-on:getGroupTypeVal="getGroupTypeVal"
                ></select-multiple>

                <select-multi-orgs ref="selectMultiOrgs" v-model="formSearch.orgIds"></select-multi-orgs>

                <el-form-item>
                    <advanced-filter @advancedChange="advancedChange" ref="advancedFilter"></advanced-filter>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getDialogUsers">{{$t('c.query')}}</el-button>
                </el-form-item>
            </el-form>

            <data-tables class="user-table"
                         ref="dialogUserTable"
                         :data="dialogTableData"
                         :table-props="dialogTableProps"
                         :current-page.sync="currentPageDialog"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                         @selection-change="handleSelectionChange"
            >
                <!-- column checkbox -->
                <!-- :selectable="initDialogTableCheckbox"-->
                <el-table-column
                    type="selection"
                    width="55px"
                    :reserve-selection="true"
                    align="center">
                </el-table-column>
                <!-- column title -->
                <el-table-column property="name" :label="$t('c.username')" align="center"
                              sortable></el-table-column>
                <el-table-column v-if="notStudent" property="typeName" :label="$t('c.occupation')" width="110px" align="center" sortable>
                    <template slot-scope="scope">
                        <span class="type-bg" :class="typeBg(scope.row.type)">{{scope.row.typeName}}</span>
                    </template>
                </el-table-column>
                <el-table-column v-for="title in dialogTitles" :prop="title.prop" :label="title.label"
                                 :key="title.label"
                                 align="center"
                                 sortable="custom">
                </el-table-column>
            </data-tables>
            <div slot="footer" style="text-align: center;">
                <el-button type="primary" @click="dialogSave" style="padding: 10px 50px;font-size: 16px;">
                    {{$t('c.save')}}

                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import api from '@/api';
    import FullScreen from '@/components/FullScreen';
    import selectMultiple from '@/components/Selectmultiple'
    import AdvancedFilter from '@/components/AdvancedFilter';
    import selectMultiOrgs from '@/components/SelectMultiOrgs';

    export default {
        components: {
            FullScreen, selectMultiple, AdvancedFilter, selectMultiOrgs
        },
        props: {
            traineeDialog: {
                type: Boolean,
                default: false,
            },
            // 打开dialog前就已选择的数据
            selectedTable: Array,
            /**
             *  打开dialog后，对前置数据selectedTable的处理方式
             *  1:从dialog列表中剔除selectedTable中的数据（默认）
             *  2:从dialog列表中勾选selectedTable中的数据
             */
            filterType: {
                type: Number,
                default: 1
            },
            notStudent: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                visible: false,
                selectNames: [{key: "groupType"}],
                formSearch: {
                    search: '',
                    orgIds: [],
                    groupIds: [],
                    advancedAccountNos: []
                },
                dialogTableProps: {
                    border: false,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "50vh"
                },
                dialogTableData: [],
                dialogTitles: [
                    {
                        prop: 'accountNo',
                        label: this.$t('c.account')
                    }, {
                        prop: 'orgName',
                        label: this.$t('c.organizations')
                    }, {
                        prop: 'postName',
                        label: this.$t('c.position')
                    }, {
                        prop: 'gradeName',
                        label: this.$t('c.grade')
                    }
                ],
                currentPageDialog: 1,
                selectedUsers: [],
                types:[3]
            }
        },
        created() {
            if (this.notStudent) {
                this.types = [1,2,3]
            }else{
                this.types = [3]
            }
        },
        methods: {
            initDialog() {
                this.formSearch = {
                    search: '',
                    orgIds: [],
                    groupIds: [],
                };
                this.$refs.advancedFilter && this.$refs.advancedFilter.reset();

                this.getDialogUsers().then(res => {
                    if (this.filterType === 2) {
                        // 将已选择的成员勾选上
                        let dialogUserTable = this.$refs.dialogUserTable.$refs.elTable;

                        this.dialogTableData.map(row => {
                            if (this.selectedTable.find(v => (v.userID == row.id || v.userId == row.id))) {
                                dialogUserTable.toggleRowSelection(row, true);
                            }
                        });
                    }
                })
            },

            getDialogUsers() {
                this.currentPageDialog = 1;
                let queryData = {
                    types: this.types,
                    ...this.formSearch
                };

                return api.queryTrainee(queryData).then(res => {
                    let data = res.package;
                    data.forEach(item => {
                        item.postName = item.postName ? item.postName : '';
                        item.gradeName = item.gradeName ? item.gradeName : '';
                    });
                    this.dialogTableData = data;

                    if (this.filterType === 1) {
                        // 将已选择的成员从列表中剔除
                        this.selectedTable.forEach((item) => {
                            let index = this.dialogTableData.findIndex(v => (v.id == item.userID || v.id == item.userId));
                            if (index > -1) {
                                this.dialogTableData.splice(index, 1)
                            }
                        });
                    }

                });
            },

            handleSelectionChange(val) {
                this.selectedUsers = val
            },

            /**
             * return Object Array
             */
            dialogSave() {
                this.$emit('dialog-save', this.selectedUsers);
            },

            initDialogTableCheckbox(row) {
                return !this.tableData.find(v => v.userID === row.id);
            },
            getGroupTypeVal(data) {
                this.formSearch.groupIds = data;
            },
            advancedChange(data) {
                this.formSearch.advancedAccountNos = data;
            },
            typeBg(type){
                let typeColor=''
                switch (type){
                    case 2:
                        typeColor='trainer';
                        break;
                    case 3:
                        typeColor='student';
                        break;
                    case 1:
                        typeColor='admin';
                        break;
                    default:
                        typeColor=''
                }
                return typeColor
            }
        },
        watch: {
            visible(val) {
                // 打开
                if (val) {
                    this.initDialog();
                    // 关闭
                } else {
                    let dialogUserTable = this.$refs.dialogUserTable.$refs.elTable;
                    dialogUserTable.clearSelection();

                    this.$refs.selectMultiOrgs.resetChecked()

                    this.$emit('update:traineeDialog', false)
                }
            },
            traineeDialog() {
                this.visible = this.traineeDialog;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .type-bg{
        display: inline-block;
        width: 80px;
        border-radius: 1px;
        color: #fff;
        &.trainer{
            background-color: #2e7faa;
        }
        &.student{
            background-color:#ffb822;
        }
        &.admin{
            background-color:#f4516c;
        }
    }
</style>

<style lang="scss">
    .trainee-dialog {
        min-width: 860px;
    }
</style>
